import { render } from "./MadeInSection.vue?vue&type=template&id=75ebcc20&scoped=true"
import script from "./MadeInSection.vue?vue&type=script&lang=js"
export * from "./MadeInSection.vue?vue&type=script&lang=js"

import "./MadeInSection.vue?vue&type=style&index=0&id=75ebcc20&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ebcc20"]])

export default __exports__